import threeDots from 'images/icon/three_dots.svg';
import * as React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import Dropdown from '../../components_v2/dropdown/Dropdown';
import InputFile from '../../components_v2/input/InputFile';
import { PrimaryColor, FilterPrimaryColor, PastelPrimaryColor, RedSidely } from '../../styles/global/css/Utils';
import { AlertRes } from '../alert/AlertProvider';
import useAlert from '../alert/UseAlert';
import { ToolbarState } from '../globals/mainPage/mainPage';
import { LoadingStateEnum } from '../import/model';
import { ComponentLoader } from '../map/modalRight/ModalCalendar';
import { FlexDiv } from '../products/style';
import AllowDenyListPopup from '../allow-deny-list/popup';
import PermissionContext from '../permissions/PermissionContext';
import Popup from '../../components_v2/popup/Popup';
import { PopupMode } from '../../components_v2/popup/model/Model';
import { confirmFileManagerPost, deleteUuid, GetFile, getPath, getUsage, postFileManagerGetUrl, postToS3, rename, setFileIcon } from './actions';

import FolderImage from 'images/filemanager/folder.svg';

import FileBlueImage from 'images/filemanager/file_blue.svg';
import FileGreenImage from 'images/filemanager/file_green.svg';
import FileOrangeImage from 'images/filemanager/file_orange.svg';
import FileSalmonImage from 'images/filemanager/file_salmon.svg';
import NewFileImage from 'images/filemanager/new_file.svg';


import { FileText, Folder as AddFolder, HousePlus, Image, LockKeyhole, Pencil, Trash } from 'lucide-react';
import { DropdownData } from '../../components_v2/dropdown/model/Model';
import { FileResult } from '../../components_v2/input/model/Model';
import { translateToString } from '../../styles/global/translate';
import { ToolbarImageContainer } from '../globals/defaultToolbar/style/Style';
import { uploadFile } from './utils';

const MAX_FILES_LIMIT_IN_MIB = 2048;

const GedBody = styled.div`
	display: flex;
	width: 100%;
	min-height: calc(100vh - 250px);
	margin-left: 10px;
	padding-bottom: 20px;
	flex-wrap: wrap;
	gap: 1px;
	align-content: flex-start;
`;

const Footer = styled.div`
	width: 100%;
	margin-top: 45px;
	margin-left: 10px;
	padding-bottom: 20px;
`;

const FileLabel = FlexDiv.extend`
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  width: 100px;
  text-align: center;
  word-wrap: break-word;
  height: 55px;
`;

const FolderLabel = FileLabel.extend`
	//top: 80px;
`;

const ProgressBarStyle = styled.div`
	font-size: 11px;
	padding-right: 20px;
	.progress .progress-bar {
		background-color: ${PrimaryColor};
		width: 100%;
	}
	.progress {
		width: 200px;
		height: 5px !important;
	}
`;

const Item = styled.div`
	display: flex;
	flex-direction: column;
	height: 120px;
	width: 100px;
	justify-content: top;
	align-items: center;
	margin-inline: 4px;
	position: relative;
	gap: 4px;
`;

const Folder = styled.div<{ icon?: string }>`
	height: 50px;
	width: 50px;
	background-image: url(${p => p.icon ?? FolderImage});
	background-repeat: no-repeat;
	background-size: 100%;
	&:hover {
		opacity: 0.5;
		cursor: pointer;
	}
`;

interface FileProps {
	file: string;
}

const File = styled.div<FileProps>`
	height: 50px;
	width: 50px;
	background-image: url(${(props) => props.file});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	overflow-wrap:  break-word;
	&:hover {
		cursor: pointer;
		opacity: 0.5;
	}
`;

const IconChoice = styled.div`
	padding: 8px 12px;
	border-radius: 5px;
	border: 1px dashed ${PrimaryColor};
	color: ${PrimaryColor};
	font-size: 12px;
	cursor: pointer;
	&:hover {
		background-color: ${PastelPrimaryColor};
	}
`;

const BlueResetText = styled.div`
	color: ${PrimaryColor};
	font-size: 12px;
	cursor: pointer;
	width: fit-content;
`;

const DropDownContainer = styled.div`
	position: absolute;
	top: 0px;
	right: 0px;
	opacity: 0.3;
	&:hover {
		cursor: pointer;
		opacity: 1;
	}
`;


const NewFolder = styled.div`
	height: 25px;
	width: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	&:hover {
		filter: ${FilterPrimaryColor};
	}
`;

const UploadBody = styled.div`
	display: flex;
	width: 100%;
	min-height: calc(100vh - 300px);
	margin-left: 10px;
	padding-bottom: 20px;
	flex-wrap: wrap;
	background-image: url(${NewFileImage});
	background-position: center;
	background-size: 12%;
	background-repeat: no-repeat;

`;

const BreadCrumbItem = styled.a`
	cursor: pointer;
	padding: 8px;
  	border-radius: 13px;
	&:hover {
		background-color: ${PastelPrimaryColor};
	}
`;

const whiteListedExtensions: string[] = [
	// Images
	'.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp',
	// Documents
	'.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.rtf', '.odt', '.ods', '.odp',
	// Autres formats utiles
	'.csv', '.ics', '.vcf', '.json', '.xml'
	// // Audio
	// '.mp3', '.wav', '.ogg', '.m4a',
	// // Vidéo
	// '.mp4', '.mov', '.avi', '.mkv', '.webm',
];

function path_to_filename(p: string) {
	return p.split('/').pop();
}

function clickDownload(blob, path) {
	const a = document.createElement('a');
	a.download = path_to_filename(path);
	a.href = blob;
	a.target = '_blank';
	a.click();
	a.remove();
}


function launchToastError(message: string) {
	toast.error(message, {
		position: 'top-right',
		autoClose: 10000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
}

export function FileManager(props: { setToolBarState: (value: ToolbarState) => void }): JSX.Element {
	const [files, setFiles] = React.useState<GetFile[]>([]);
	const [currentPath, setCurrentPath] = React.useState<string>('/');
	const [folders, setFolders] = React.useState<GetFile[]>([]);
	const alert = useAlert();
	const [usage, setUsage] = React.useState<number>(0);
	const [update, setUpdate] = React.useState<number>(0);
	const [loadingState, setLoadingState] = React.useState(LoadingStateEnum.LOADED);
	const [dragging, setDragging] = React.useState(false);
	const [iconPicker, setIconPicker] = React.useState<GetFile>();
	const [restrictionTarget, setRestrictionTarget] = React.useState<GetFile>();
	const { isAllowedTo } = React.useContext(PermissionContext);
	const canRestrict = isAllowedTo({ objectAction: 'CreateCompanySettings' });
	const restrictOption = canRestrict ? [{ label: translateToString('allow_deny_list.restrictions'), value: 'restrict', imageJsx: <LockKeyhole size={16} /> }] : [];
	const entryMenu: DropdownData[] = [
		{ label: translateToString('edit'), value: 'edit', imageJsx: <Pencil size={16} /> },
		{ label: translateToString('file_manager.change_icon'), value: 'icon', imageJsx: <Image size={16} /> },
		...restrictOption,
		{ label: translateToString('delete'), value: 'delete', imageJsx: <Trash size={16} color={RedSidely} /> },
	];
	const entryMenuStyle = {
		optionWidth: '190px',
		optionHeight: 'fit-content',
		optionPadding: '7px 10px',
		optionFontSize: '13px',
		optionLeft: '0px',
		margin: '0 0 0 auto',
	};
	const iconInputRef = React.useRef<HTMLInputElement>(null);

	const driveEntryName = (path: string): string => path.endsWith('/')
		? path.substring(1 + path.lastIndexOf('/', path.length - 2), path.length - 1)
		: path_to_filename(path) ?? path;

	const clearIcon = (target: GetFile) => {
		setLoadingState(LoadingStateEnum.LOADING);
		setFileIcon(target.uuid, null).then(() => {
			setIconPicker(undefined);
			setUpdate(update => update + 1);
			setLoadingState(LoadingStateEnum.LOADED);
		}).catch(() => {
			setLoadingState(LoadingStateEnum.ERROR);
			toast.error(translateToString('error'));
		});
	};

	// The icon image lands in the company's filemanager S3 space through the
	// same presigned flow as file uploads; only icon_id is stored on the row,
	// the listing presigns icon_url back.
	const applyIconUpload = (target: GetFile, file: FileResult) => {
		setLoadingState(LoadingStateEnum.LOADING);
		postFileManagerGetUrl()
			.then(res => postToS3(res.url, file).then(() => setFileIcon(target.uuid, res.uuid)))
			.then(() => {
				setIconPicker(undefined);
				setUpdate(update => update + 1);
				setLoadingState(LoadingStateEnum.LOADED);
			}).catch(() => {
				setLoadingState(LoadingStateEnum.ERROR);
				toast.error(translateToString('error'));
			});
	};
	const inputFileRef = React.useRef<HTMLInputElement>(null);

	const img = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
	const pres = ['.pdf', '.ppt', '.pptx', '.odp'];
	const sheets = ['.xls', '.xlsx', '.ods', '.csv', '.ics', '.vcf', '.json', '.xml'];
	//const doc = ['.doc', '.docx', '.txt', '.rtf', '.odt']; everything else

	function isFileType(filename: string, extensions: string[]): boolean {
		return extensions.some(ext => filename.toLowerCase().endsWith(ext));
	}

	function selectSVG(path: string) {
		const filename = path_to_filename(path);
		if (isFileType(filename, pres)) {
			return FileSalmonImage;
		}
		if (isFileType(filename, img)) {
			return FileOrangeImage;
		}
		if (isFileType(filename, sheets)) {
			return FileGreenImage;
		}
		return FileBlueImage;
	}

	React.useEffect(() => {
		getPath(currentPath).then(f => {
			setFolders(f.filter(f => (f.path.endsWith('/') && f.path != currentPath)));
		});
	}, [update, currentPath]);

	React.useEffect(() => {
		setLoadingState(LoadingStateEnum.LOADING);
		getPath(currentPath).then(f => setFiles(f.filter(f => !f.path.endsWith('/'))));
		getUsage().then(u => setUsage((u / 1024 / 1024)));
		setLoadingState(LoadingStateEnum.LOADED);

		props.setToolBarState({
			title: translateToString('file_manager.files'),
			bottomLeftToolbarComponent: <>

				<BreadCrumbItem onClick={() => setCurrentPath('/')}>
					<FlexDiv gap='8px'><ToolbarImageContainer><HousePlus /></ToolbarImageContainer>/</FlexDiv>
				</BreadCrumbItem>
				{currentPath.split('/').map((breadcrumb, index) => {
					if (index === 0 || index + 1 === currentPath.split('/').length) return null;
					return <React.Fragment key={index}>
						<BreadCrumbItem
							onClick={() => {
								// rebuild path using index
								let newPath = '/';
								for (let i = 1; i <= index; i++) {
									newPath += currentPath.split('/')[i] + '/';
								}
								setCurrentPath(newPath);
							}}
						>
							{breadcrumb}
						</BreadCrumbItem>
						/
					</React.Fragment>;
				})}
			</>,
			bottomRightToolbarComponent: <>
				<FlexDiv gap='4px'>
					<NewFolder
						onClick={
							() => {
								const newFolder = prompt(translateToString('file_manager.enter_new_folder_name'));
								if (newFolder) {
									if (!folders.find((f) => f.path === (currentPath + newFolder + '/'))) {
										setLoadingState(LoadingStateEnum.LOADING);
										confirmFileManagerPost({ path: currentPath + newFolder + '/', filesize: 0 }).then(() => setUpdate(update + 1));
									}
									else {
										launchToastError(translateToString('file_manager.directory_already_exist'));
									}
								}
							}
						}
					>
						<AddFolder size={20} />
					</NewFolder>
					<NewFolder
						onClick={() => {
							if (inputFileRef.current) {
								inputFileRef.current.click();
							}
						}}>
						<FileText size={20} />
						<InputFile
							display='none'
							inputRef={inputFileRef}
							hideAddIcon={true}
							limitMiB={Math.round((MAX_FILES_LIMIT_IN_MIB - usage) * 100) / 100}
							onChange={(file) => {
								if (files.find(f => path_to_filename(f.path) === file.file.name)) {
									launchToastError(translateToString('file_manager.file_already_exist'));
									return;
								}
								if (!whiteListedExtensions.some(str => file.file.name.toLowerCase().endsWith(str)) || file.file.name.includes('?') || file.file.name.includes('%')) {
									launchToastError(translateToString('file_manager.filename_forbidden'));
									return;
								}

								setLoadingState(LoadingStateEnum.LOADING);
								if (!files.find(f => path_to_filename(f.path) === file.file.name)) {
									uploadFile(file, currentPath).then(_msg => {
										setUpdate(update + 1);
									});
								}
							}}
							onError={e => launchToastError(e.message)}
						/>
					</NewFolder>
				</FlexDiv>
			</>
		});

	}, [currentPath, update, folders]);

	const currentFolder = currentPath.split('/')[currentPath.split('/').length - 2];

	return <>
		<ComponentLoader loadingState={loadingState} allScreen />

		{dragging && <UploadBody
			onDragOver={
				(ev) => {
					ev.preventDefault();
				}
			}
			onDragLeave={
				(ev) => {
					ev.preventDefault();
					setDragging(false);
				}
			}
			onDrop={
				async(ev) => {
					ev.preventDefault();
					if (ev.dataTransfer.files[0].size === 0) {
						launchToastError('Vous ne pouvez pas envoyer de dossiers.');
						setDragging(false);
						return;
					}


					let totalSize = 0;
					for (let i = 0; i < ev.dataTransfer.files.length; i++) {
						totalSize += ev.dataTransfer.files[i].size;
					}

					if (MAX_FILES_LIMIT_IN_MIB && parseFloat(((totalSize / 1024) / 1024).toFixed(4)) > MAX_FILES_LIMIT_IN_MIB) {
						launchToastError('Vous avez dépassé la limite de stockage de ' + MAX_FILES_LIMIT_IN_MIB + 'MiB. Veuillez supprimer des fichiers pour continuer. ');
						setDragging(false);
						return;
					}

					setLoadingState(LoadingStateEnum.LOADING);

					const uploadPromises: Promise<string>[] = [];
					for (let i = 0; i < ev.dataTransfer.files.length; i++) {
						const file = ev.dataTransfer.files[i];
						if (file != null) {
							const errorFilename = (messageKey) => {
								launchToastError(translateToString(messageKey));
								setLoadingState(LoadingStateEnum.LOADED);
								setDragging(false);
							};
							if (files.some(f => path_to_filename(f.path) === file.name)) {
								errorFilename('file_manager.file_already_exist');
								continue;
							}
							if (!whiteListedExtensions.some(ext => file.name.toLowerCase().endsWith(ext))) {
								errorFilename('file_manager.filename_forbidden');
								continue;
							}
							const url = URL.createObjectURL(file);



							const p = new Promise(() => {
								const reader = new FileReader();
								reader.onload = async evt => {
									const tab = evt.target?.result?.toString().split(',');
									const contents = (tab != null) ? tab[1] : '';
									const contentType = (tab != null) ? tab[0] : '';
									const f: FileResult = {
										file,
										content: contents,
										contentType,
										url
									};
									uploadFile(f, currentPath).then(_msg => {
										setUpdate(update => update + 1);
										setDragging(false);
									});
								};
								reader.readAsDataURL(file);
							});
							uploadPromises.push(p as Promise<string>);
						}
					}
					await Promise.all(uploadPromises);

				}
			}
		>
		</UploadBody>}
		{!dragging && <GedBody
			onDragOver={
				(ev) => {
					ev.preventDefault();
					setDragging(true);
				}
			}
		>

			{ // map folders and filter out current folder
				folders.filter(folder => folder.path !== currentPath + currentFolder).map((folder, index) =>
					<Item key={`file${index}`}>
						<Folder
							key={index}
							icon={folder.icon_url ?? undefined}
							onClick={() => {
								setCurrentPath(folder.path);
							}}
						>
						</Folder>
						<FolderLabel>{folder.path.substring(1 + folder.path.lastIndexOf('/', folder.path.lastIndexOf('/') - 1))}</FolderLabel>
						<DropDownContainer>
							<Dropdown
								datalist={entryMenu}
								name='dropdown_actions'
								searchable={false}
								readOnly
								JSXButton={() => (
									<img
										src={threeDots}
										className="custom-icon"
										style={{ marginTop: '3px' }}
										alt=""
									/>
								)}
								dropdownStyle={entryMenuStyle}
								onChange={(value: DropdownData) => {
									switch (value.value) {
										case 'restrict':
											setRestrictionTarget(folder);
											break;
										case 'icon':
											setIconPicker(folder);
											break;
										case 'edit':
											// eslint-disable-next-line no-case-declarations
											const newName = prompt(translateToString('file_manager.enter_new_folder_name'));
											if (newName) {
												setLoadingState(LoadingStateEnum.LOADING);
												rename(folder.path, currentFolder + '/' + newName + '/').then(() => {
													setUpdate(update => update + 1);
												}).catch(() => {
													setLoadingState(LoadingStateEnum.ERROR);
													toast.error(translateToString('error'));
												});
											}
											break;
										case 'delete':
											alert({
												title: translateToString('file_manager.deleting_folder'),
												content: translateToString('file_manager.delete_folder_sure'),
												mode: 'delete'
											}).then(res => {
												if (res.res === AlertRes.Ok) {
													setLoadingState(LoadingStateEnum.LOADING);
													deleteUuid(folder.uuid).then(() => {
														setUpdate(update => update + 1);
													}).catch((e) => {
														setLoadingState(LoadingStateEnum.ERROR);
														if (e.response && e.response.status === 400)
															toast.error(translateToString('file_manager.folder_not_empty'));
													});
												}
											});
											break;
										default:
											break;
									}
								}}
							/>
						</DropDownContainer>
					</Item>)}
			{files.map((file, index) =>
				<Item key={`file${index}`}>
					<File file={file.icon_url ?? selectSVG(file.path)} onClick={() => {
						alert({
							title: translateToString('file_manager.file_download'),
							content: translateToString('file_manager.are_you_sure_download') + path_to_filename(file.path) + ' ?',
						}).then(res => {
							if (res.res === AlertRes.Ok) {
								clickDownload(file.url, file.path);
							}
						});
					}} />
					<FileLabel>{path_to_filename(file.path)}</FileLabel>
					<DropDownContainer>
						<Dropdown
							datalist={entryMenu}
							name='dropdown_actions'
							searchable={false}
							readOnly
							JSXButton={() => (
								<img
									src={threeDots}
									className="custom-icon"
									style={{ marginTop: '3px' }}
									alt=""
								/>
							)}
							dropdownStyle={entryMenuStyle}
							onChange={(value: DropdownData) => {
								switch (value.value) {
									case 'restrict':
										setRestrictionTarget(file);
										break;
									case 'icon':
										setIconPicker(file);
										break;
									case 'edit':
										// eslint-disable-next-line no-case-declarations
										const newName = prompt(translateToString('file_manager.enter_new_filename'));
										if (newName) {
											setLoadingState(LoadingStateEnum.LOADING);
											rename(file.path, currentFolder + newName).then(() => {
												setUpdate(update => update + 1);
											}).catch(() => {
												setLoadingState(LoadingStateEnum.ERROR);
												toast.error(translateToString('error'));
											});
										}
										break;
									case 'delete':
										alert({
											title: translateToString('file_manager.are_you_sure'),
											content: translateToString('file_manager.are_you_sure_delete') + path_to_filename(file.path) + '?',
										}).then(res => {
											if (res.res === AlertRes.Ok) {
												setLoadingState(LoadingStateEnum.LOADING);
												deleteUuid(file.uuid).then(() => {
													setUpdate(update => update + 1);
												});
											}
										});
										break;
									default:
										break;
								}
							}}
						/>
					</DropDownContainer>
				</Item>)}

		</GedBody>}
		{restrictionTarget && <AllowDenyListPopup
			isOpen
			onClose={() => setRestrictionTarget(undefined)}
			objectActions={['ViewDoc']}
			targetUuid={restrictionTarget.uuid}
			titles={{ ViewDoc: driveEntryName(restrictionTarget.path) }}
		/>}
		{iconPicker && <Popup
			isOpen
			popupMode={PopupMode.Centered}
			popupStyle={{ width: '420px', fitContent: true, animate: false }}
			onClickOut={() => setIconPicker(undefined)}
		>
			<FlexDiv flow='column' gap='15px' padding='20px' align='stretch'>
				<h4 style={{ margin: 0 }}>{translateToString('file_manager.change_icon')}</h4>
				<FlexDiv gap='15px'>
					{iconPicker.icon_url && <img src={iconPicker.icon_url} width={50} height={50} style={{ objectFit: 'contain' }} alt='' />}
					<IconChoice onClick={() => iconInputRef.current?.click()}>
						{translateToString('file_manager.upload_icon')}
					</IconChoice>
				</FlexDiv>
				<InputFile
					display='none'
					inputRef={iconInputRef}
					hideAddIcon
					accept='image/png,image/jpeg,image/svg+xml,image/webp,image/gif'
					limitMiB={2}
					onChange={(file) => applyIconUpload(iconPicker, file)}
					onError={(e) => launchToastError(e.message)}
				/>
				{iconPicker.icon_id && <BlueResetText onClick={() => clearIcon(iconPicker)}>
					{translateToString('file_manager.reset_icon')}
				</BlueResetText>}
			</FlexDiv>
		</Popup>}
		<Footer>
			<FlexDiv>
			</FlexDiv>
			{translateToString('file_manager.storage_usage')}
			<ProgressBarStyle>
				<ProgressBar
					now={Math.round(usage * 100) / 100}
					min={0}
					max={MAX_FILES_LIMIT_IN_MIB}
					variant={usage > MAX_FILES_LIMIT_IN_MIB * 0.5 ? usage > MAX_FILES_LIMIT_IN_MIB * 0.8 ? 'danger' : 'warning' : 'success'}
				/>
				<div>{Math.round(usage * 100) / 100}MiB / {MAX_FILES_LIMIT_IN_MIB / 1024}GiB</div>
			</ProgressBarStyle>
		</Footer>

	</>;
}
